import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ImportFileResponse, ImportFileResponseEmployee } from '../../../state/import.model';
import { ImportEntityType } from '../import-by-entity/import-by-entity.component';

@Component({
    selector: 'app-import-by-entity-preview',
    templateUrl: './import-by-entity-preview.component.html',
    styleUrls: ['./import-by-entity-preview.component.css'],
})
export class ImportByEntityPreviewComponent {
    @Input() public importFileResponse: ImportFileResponse;
    @Input() public importFileResponseEmployee: ImportFileResponseEmployee;
    @Input() public entity: ImportEntityType;
    @Input() public confirmImportForm: FormGroup;

    public constructor() { }
}
